import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { CoachExperience } from "../../models/coachexperience"

@Injectable({
  providedIn: "root",
})
export class CoachExperienceDisplayDataResolver
  implements DisplayDataResolver<CoachExperience>
{
  typeDisplayName = "CoachExperience"

  constructor() {}

  getIcon(entity: CoachExperience): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: CoachExperience): string | undefined {
    return undefined
  }

  getSubTitle(entity: CoachExperience): string | undefined {
    return undefined
  }

  getTitle(entity: CoachExperience): string {
    return entity.id
  }

  getShortTitle(entity: CoachExperience): string {
    return entity.id
  }

  getItemHref(entityOrID: CoachExperience | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/coachExperience"
    }
    if (typeof entityOrID === "string") return "/app/coachExperience/" + entityOrID
    return "/app/coachExperience/" + entityOrID.id
  }
}
